var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBillIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.17 1.33337H4.83001C4.05743 1.33337 3.67114 1.33337 3.35959 1.44178C2.76881 1.64734 2.30499 2.12483 2.1053 2.73302C2 3.05374 2 3.45141 2 4.24675V13.5828C2 14.155 2.65666 14.4586 3.07206 14.0784C3.31612 13.8551 3.68388 13.8551 3.92794 14.0784L4.25 14.3732C4.67772 14.7646 5.32228 14.7646 5.75 14.3732C6.17772 13.9818 6.82228 13.9818 7.25 14.3732C7.67772 14.7646 8.32228 14.7646 8.75 14.3732C9.17772 13.9818 9.82228 13.9818 10.25 14.3732C10.6777 14.7646 11.3223 14.7646 11.75 14.3732L12.0721 14.0784C12.3161 13.8551 12.6839 13.8551 12.9279 14.0784C13.3433 14.4586 14 14.155 14 13.5828V4.24675C14 3.45141 14 3.05374 13.8947 2.73302C13.695 2.12483 13.2312 1.64734 12.6404 1.44178C12.3289 1.33337 11.9426 1.33337 11.17 1.33337Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33331 6.93337L7.28569 8.00004L9.66665 5.33337",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.3334H11",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/BillIcon.a867a3737427ff7d061eb8858bde3c5b.svg";
export { ForwardRef as ReactComponent };